import { connect } from 'react-redux'
import ServiceDeskMyCity from './component'

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ServiceDeskMyCity)
